import { render, staticRenderFns } from "./TypeFormLeads.vue?vue&type=template&id=6b819730&scoped=true&"
import script from "./TypeFormLeads.vue?vue&type=script&lang=js&"
export * from "./TypeFormLeads.vue?vue&type=script&lang=js&"
import style0 from "./TypeFormLeads.vue?vue&type=style&index=0&id=6b819730&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b819730",
  null
  
)

export default component.exports